module.exports = __webpack_public_path__ + "img/ic-influencers.a620ad43.svg";